import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { RadioButton } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

type EmailPersonalizationOptionProps = {
    isSelected: boolean;
    isDisabled?: boolean;
    title: string;
    subtitle: string;
    badge?: ReactNode;
    onSelect?: () => void;
    dataAutomation: string;
};

export const EmailPersonalizationOption = ({
    isSelected,
    isDisabled = false,
    title,
    subtitle,
    badge,
    onSelect,
    dataAutomation,
}: EmailPersonalizationOptionProps) => {
    const handleSelect = isDisabled ? undefined : onSelect;

    return (
        <Flex
            flex="1"
            alignItems="flex-start"
            padding="12px 12px 12px 0"
            borderRadius="6px"
            cursor={isDisabled ? "not-allowed" : "pointer"}
            opacity={isDisabled ? 0.6 : 1}
            background={isSelected ? colorsPalettes.blue["50"] : colorsPalettes.carbon["0"]}
            border={
                isSelected ? `1px solid ${colorsPalettes.blue["400"]}` : `1px solid ${colorsPalettes.midnight["50"]}`
            }
            whenHover={{ borderColor: isSelected ? colorsPalettes.blue["400"] : colorsPalettes.blue["200"] }}
            onClick={handleSelect}
            data-automation={dataAutomation}
        >
            <RadioButton
                itemSelected={isSelected}
                itemDisabled={isDisabled}
                onClick={handleSelect}
                renderLabel={() => (
                    <Stack
                        gap="4px"
                        margin="0 0 0 16px"
                    >
                        <Flex
                            alignItems="center"
                            gap="8px"
                        >
                            <Text
                                fontVariant="subtitle2"
                                color={colorsPalettes.carbon["500"]}
                                data-automation={`${dataAutomation}-title`}
                            >
                                {title}
                            </Text>
                            {badge}
                        </Flex>
                        <Text
                            fontVariant="body2"
                            color={colorsPalettes.carbon["300"]}
                            data-automation={`${dataAutomation}-subtitle`}
                        >
                            {subtitle}
                        </Text>
                    </Stack>
                )}
            />
        </Flex>
    );
};
